/* eslint-disable no-param-reassign */
import { useState } from 'react';
import { Inputbox } from '@zeeve-platform/inputbox-component';
import { NodeDataZoneTypes } from '../declaration';

interface Props {
  cardnumber: number;
  nodeDataZone: NodeDataZoneTypes[];
  setNodeFlag: (x: boolean) => void;
  setNodeDataZone: (obj: NodeDataZoneTypes[]) => void;
  setNodeCount: (x: number) => void;
  nodeCount: number;
}

const NodeCard = ({
  setNodeDataZone,
  cardnumber,
  nodeDataZone,
  setNodeFlag,
  setNodeCount,
  nodeCount,
}: Props) => {
  const [showNext, setNext] = useState({
    s1: false,
    s2: false,
    s3: false,
    s4: false,
  });

  const [update, setUpdate] = useState<boolean>(true);
  const [valid, setValid] = useState(true);
  const rpcAccessPoint = ['HTTP', 'WS'];

  const unsetHighlight = (x: string, flag: boolean) => {
    const b = document.getElementById(x);
    if (b) {
      if (flag) {
        if (b.classList.contains('formEmptyText')) {
          b.classList.remove('formEmptyText');
        }
      } else {
        b.style.borderColor = '#ECEEF3';
      }
    }
  };

  const highlight = (x: string, flag: boolean) => {
    const b = document.getElementById(x);
    if (b) {
      if (flag) {
        if (!b.classList.contains('formEmptyText')) {
          b.classList.add('formEmptyText');
        }
      } else {
        b.style.borderColor = 'red';
      }
    }
  };

  const checkUnique = (x: string, index: number) => {
    for (let i = 0; i < nodeCount; i += 1) {
      if (
        nodeDataZone[i].nodeName
        && x === nodeDataZone[i].nodeName
        && i !== index
      ) {
        return false;
      }
    }
    return true;
  };

  const handleInput = (val: string, op: string) => {
    const usernamePattern = /[^a-zA-Z0-9]/g;
    const etag = document.getElementById('err');
    let res;
    switch (op) {
      case 'user':
        res = val.match(usernamePattern);
        if (res) {
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Invalid username format. Use only alphabets and digits';
          }
          setValid(false);
          setNodeFlag(false);
          highlight(`z15_${cardnumber}`, false);
        } else if (val.length < 8) {
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the username should not be less than 8.';
          }
          setValid(false);
          setNodeFlag(false);
          highlight(`z15_${cardnumber}`, false);
        } else if (val.length > 20) {
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the username should not be more than 20.';
          }
          setNodeFlag(false);
          setValid(false);
          highlight(`z15_${cardnumber}`, false);
        } else {
          if (etag) {
            etag.style.display = 'none';
          }
          setValid(true);
          setNodeFlag(true);
          setNext({ ...showNext, s1: true });
          unsetHighlight(`z15_${cardnumber}`, false);
          const nObj = nodeDataZone;
          nodeDataZone[cardnumber].userName = val;
          setNodeDataZone(nObj);
          setUpdate(!update);
        }
        break;
      case 'pass':
        res = val.match(usernamePattern);
        if (res) {
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Invalid password format. Use only alphabets and digits';
          }
          setValid(false);
          setNodeFlag(false);
          highlight(`z12_${cardnumber}`, false);
        } else if (val.length < 8) {
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the password should not be less than 8.';
          }
          setValid(false);
          setNodeFlag(false);
          highlight(`z12_${cardnumber}`, false);
        } else if (val.length > 20) {
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the password should not be more than 20.';
          }
          setValid(false);
          setNodeFlag(false);
          highlight(`z12_${cardnumber}`, false);
        } else {
          if (etag) {
            etag.style.display = 'none';
          }
          setValid(true);
          setNodeFlag(true);
          unsetHighlight(`z12_${cardnumber}`, false);
          setNext({ ...showNext, s2: true });
          const nObj = nodeDataZone;
          nodeDataZone[cardnumber].password = val;
          setNodeDataZone(nObj);
          setUpdate(!update);
        }
        break;
      case 'instanceName':
        if (val.length < 5) {
          setValid(false);
          setNodeFlag(false);
          highlight(`nodeName-1_${cardnumber}`, false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the node name should not be less than 5.';
          }
          break;
        } else if (val.length > 20) {
          setValid(false);
          setNodeFlag(false);
          highlight(`nodeName-1_${cardnumber}`, false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the node name should not be more than 20.';
          }
          break;
        } else if (!/[a-z]/i.test(val.charAt(0))) {
          setNodeFlag(false);
          setValid(false);
          highlight(`nodeName-1_${cardnumber}`, false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Node name should start with an alphabet.';
          }
          break;
        } else if (!/^[A-Za-z0-9]*$/.test(val.charAt(val.length - 1))) {
          setNodeFlag(false);
          setValid(false);
          highlight(`nodeName-1_${cardnumber}`, false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Node name should end with an alphabet or a number.';
          }
          break;
        } else if (!/^([A-Za-z0-9\s-])*$/.test(val)) {
          setNodeFlag(false);
          setValid(false);
          highlight(`nodeName-1_${cardnumber}`, false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Node name can only contain alphabet, number, space and hyphen.';
          }
          break;
        } else if (!checkUnique(val, cardnumber)) {
          setNodeFlag(false);
          setValid(false);
          highlight(`nodeName-1_${cardnumber}`, false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Node name already exists.';
          }
          break;
        } else {
          if (etag) {
            etag.style.display = 'none';
          }
          const nObj = nodeDataZone;
          nodeDataZone[cardnumber].nodeName = val;
          setNodeDataZone(nObj);
          setValid(true);
          setNodeFlag(true);
          setNext({ ...showNext, s3: true });
          unsetHighlight(`nodeName-1_${cardnumber}`, false);
          setUpdate(!update);
        }
        break;
      default:
        break;
    }
  };

  const solve = () => {
    if (
      (showNext.s1 || nodeDataZone[cardnumber].userName)
      && (showNext.s2 || nodeDataZone[cardnumber].password)
      && (showNext.s3 || nodeDataZone[cardnumber].nodeName)
      && (showNext.s4 || checkAccessPoint())
      && valid
    ) {
      setNodeFlag(true);
    }
    if (!(showNext.s1 || nodeDataZone[cardnumber].userName)) {
      setNodeFlag(false);
      return highlight(`z15_${cardnumber}`, false);
    }
    if (!(showNext.s2 || nodeDataZone[cardnumber].password)) {
      setNodeFlag(false);
      return highlight(`z12_${cardnumber}`, false);
    }
    if (!(showNext.s3 || nodeDataZone[cardnumber].nodeName)) {
      setNodeFlag(false);
      return highlight(`nodeName-1_${cardnumber}`, false);
    }
    if (!(showNext.s4 || checkAccessPoint())) {
      setNodeFlag(false);
      return highlight('z13', true);
    }
    return false;
  };
  const checkAccessPoint = () => {
    if (nodeDataZone[cardnumber] && nodeDataZone[cardnumber].rpcAccessPoint) {
      return (
        nodeDataZone[cardnumber].rpcAccessPoint.https
        || nodeDataZone[cardnumber].rpcAccessPoint.wss
      );
    }
    return false;
  };

  const handleRpcAccessPoint = (op: string) => {
    const nObj = nodeDataZone;
    if (op === 'https') {
      const old = nObj[cardnumber].rpcAccessPoint;
      if (old) {
        old.https = !old.https;
        nObj[cardnumber].rpcAccessPoint = old;
      } else {
        const obj = { https: true, wss: false };
        nObj[cardnumber].rpcAccessPoint = obj;
      }
    }
    if (op === 'wss') {
      const old = nObj[cardnumber].rpcAccessPoint;
      if (old) {
        old.wss = !old.wss;
        nObj[cardnumber].rpcAccessPoint = old;
      } else {
        const obj = { https: false, wss: true };
        nObj[cardnumber].rpcAccessPoint = obj;
      }
    }
    setNodeDataZone(nObj);
    unsetHighlight('z13', true);
    setUpdate(!update);
  };

  return (
    <div className="mt-3 mb-5 addNodeCard">
      <div className="col-11 mx-4">
        <div className="row">
          <div
            className="mt-4 col-8 ms-3"
            title="Credentials required to access RPC server of Template"
          >
            <h6>
              RPC Access Credentials
              <i className="mx-2 fa fa-info-circle" />
            </h6>
          </div>
          <div
            className="mt-4 col-3 ms-1"
            title="Numerous people are using telemetry so it is recommended that you choose a node name something likely to be unique."
          >
            <h6>
              Node Name
              <i className="mx-1 fa fa-info-circle" />
            </h6>
          </div>
        </div>
        <div className="row ms-1">
          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div className="mt-3 col-11 form-floating cordaversion">
              <Inputbox
                type="text"
                className="form-control required"
                defaultValue={nodeDataZone[cardnumber].userName}
                autoComplete="off"
                placeholder="username"
                id={`z15_${cardnumber}`}
                onChange={(e: { target: { value: string } }) => {
                  handleInput(e.target.value, 'user');
                }}
              />
              <label htmlFor={`z15_${cardnumber}`} className="form-pswd">
                Username
              </label>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div className="mt-3 col-11 form-floating cordaversion">
              <Inputbox
                type="password"
                className="form-control required"
                defaultValue={nodeDataZone[cardnumber].password}
                placeholder="password"
                id={`z12_${cardnumber}`}
                autoComplete="off"
                onChange={(e: { target: { value: string } }) => {
                  handleInput(e.target.value, 'pass');
                }}
              />
              <label htmlFor={`z12_${cardnumber}`} className="form-pswd">
                Password
              </label>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div className="mt-3 col-11 marginauto form-floating cordaversion">
              <Inputbox
                type="text"
                className="form-control required"
                id={`nodeName-1_${cardnumber}`}
                placeholder="Node Name"
                defaultValue={
                  nodeDataZone[cardnumber].nodeName
                    ? nodeDataZone[cardnumber].nodeName
                    : ''
                }
                onChange={(e: { target: { value: string } }) => {
                  handleInput(e.target.value, 'instanceName');
                }}
              />
              <label htmlFor={`nodeName-1_${cardnumber}`} className="form-pswd">
                Node Name
              </label>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="ms-3 mt-3 col-4">
            <h6 id="z13">Enable RPC Server</h6>
            <div className="row mt-3 mx-2">
              <div className="form-check col-xl-5 col-lg-5 col-sm-5 col-md-3 RPCspace1">
                <Inputbox
                  type="checkbox"
                  className="form-check-input"
                  id={`custom-${cardnumber}-checkbox-rpc-${0}`}
                  name={rpcAccessPoint[0]}
                  value={rpcAccessPoint[0]}
                  checked={
                    nodeDataZone[cardnumber].rpcAccessPoint
                      ? nodeDataZone[cardnumber].rpcAccessPoint.https
                      : false
                  }
                  onChange={() => {
                    handleRpcAccessPoint('https');
                  }}
                />
                <label
                  className="form-check-label mx-2"
                  htmlFor={`custom-${cardnumber}-checkbox-rpc-${0}`}
                >
                  {rpcAccessPoint[0]}
                </label>
              </div>
              <div className="form-check col-xl-5 col-lg-5 col-sm-5 col-md-3 ">
                <Inputbox
                  type="checkbox"
                  className="form-check-input"
                  id={`custom-${cardnumber}-checkbox-rpc-${1}`}
                  name={rpcAccessPoint[1]}
                  value={rpcAccessPoint[1]}
                  checked={
                    nodeDataZone[cardnumber].rpcAccessPoint
                      ? nodeDataZone[cardnumber].rpcAccessPoint.wss
                      : false
                  }
                  onChange={() => {
                    handleRpcAccessPoint('wss');
                  }}
                />
                <label
                  className="form-check-label mx-2"
                  htmlFor={`custom-${cardnumber}-checkbox-rpc-${1}`}
                >
                  {rpcAccessPoint[1]}
                </label>
              </div>
            </div>
          </div>
        </div>
        <p
          id="err"
          className="text-center mt-4 mb-4"
          style={{ color: 'red', display: 'none' }}
        >
          Error
        </p>
      </div>
      {solve()}
    </div>
  );
};
export default NodeCard;
